<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800">Assessments</h1>
                </div>

                <!--<div class="card shadow noActionButtons">-->

                <div class="topSpacing">

                    <div class="desktopTabs">
                        <ul class="tab-nav">
                            <li (click)="tabSelect(0)" class="active"><a data-toggle="tab" href="#tab1">Pending</a></li>
                            <li (click)="tabSelect(1)"><a data-toggle="tab" href="#tab2">Completed</a></li>
                        </ul>
                    </div>

                    <div class="main-tab-content tab-content">
                        <div id="tab1" class="tab-pane fade in active">
                            <app-pending-assessments></app-pending-assessments>
                        </div>

                        <div id="tab2" class="tab-pane fade">
                            <app-client-completed-assessments></app-client-completed-assessments>
                        </div>
                    </div>
                </div>

                <!--</div>-->
            </div>
        </div>
    </div>
</div>